<div class="container mt-3">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <h4 class="mt-0">Event Informations</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Event name*</label>
                                        <input type="text" class="form-control form-control-sm"
                                            [(ngModel)]="eventOffer.eventName" placeholder="Event name" />
                                    </div>
                                </div>
                                <div class="col-2">
                                    <app-form-group-datepicker [label]="'request-event-modal.start-date' | translate"
                                        [(model)]="startDate" (modelChange)="calculateEventOfferPrice()">
                                    </app-form-group-datepicker>
                                </div>
                                <div class="col-2">
                                    <app-form-group-datepicker [label]="'request-event-modal.end-date' | translate"
                                        [(model)]="endDate" (modelChange)="calculateEventOfferPrice()">
                                    </app-form-group-datepicker>
                                </div>
                                <div class="col-2">
                                    <app-form-group-datepicker label="Pick Up Date" [(model)]="pickUpDate">
                                    </app-form-group-datepicker>
                                </div>
                                <div class="col-2">
                                    <app-form-group-datepicker label="Return Date" [(model)]="returnDate">
                                    </app-form-group-datepicker>
                                </div>
                            </div>
                            <app-select-location-group *ngIf="dataFetched"
                              [initialCountry]="chosenCountry"
                              [initialVillage]="chosenVillage"
                              (onVillageChosen)="onVillageSelected($event)"
                              (onCountryChosen)="onCountrySelected($event)">
                            </app-select-location-group>
                            <div class="row">
                                <div class="col-3" *ngIf="showVillageFraction">
                                    <div class="form-group">
                                        <label>Village fraction</label>
                                        <input type="text" class="form-control form-control-sm"
                                            [(ngModel)]="eventOffer.zone" placeholder="Fraction" />
                                    </div>
                                </div>
                                <div class="col-3" *ngIf="showGeneralLocationInput">
                                  <div class="form-group">
                                    <label>Location *</label>
                                    <input type="text" class="form-control form-control-sm"
                                           [(ngModel)]="eventOffer.zone" placeholder="Location" />
                                  </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label>Event language*</label>
                                        <select class="form-control form-control-sm" [(ngModel)]="eventOffer.language">
                                            <option *ngFor="let language of eventLanguageArray"
                                                [value]="language.value">
                                                {{language.label}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col">
                            <ul ngbNav #editorNav="ngbNav" [activeId]="companyTab" (navChange)="beforeChange($event)">
                                <li [ngbNavItem]="'tab-new'">
                                    <a ngbNavLink>New Organization</a>
                                    <ng-template ngbNavContent>
                                        <div class="pt-3">
                                            <div class="row">
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label>Organization*</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            [(ngModel)]="eventOffer.organizationName"
                                                            placeholder="Organization" />
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="form-group">
                                                        <label>Organization Email*</label>
                                                        <small class="help-text">
                                                            &nbsp;&nbsp;&nbsp;use semicolon to add more emails
                                                        </small>
                                                        <input type="text" class="form-control form-control-sm"
                                                            [(ngModel)]="eventOffer.organizationEmail"
                                                            placeholder="Organization Email" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-2">
                                                    <div class="form-group">
                                                        <label>Client title*</label>
                                                        <select class="form-control form-control-sm"
                                                            [(ngModel)]="eventOffer.clientTitle">
                                                            <option value="Herr">Herr</option>
                                                            <option value="Frau">Frau</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label>Client firstname*</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            [(ngModel)]="eventOffer.clientFirstName"
                                                            placeholder="Client firstname" />
                                                    </div>
                                                </div>
                                                <div class="col">
                                                  <div class="form-group">
                                                      <label>Client lastname*</label>
                                                      <input type="text" class="form-control form-control-sm"
                                                          [(ngModel)]="eventOffer.clientLastName"
                                                          placeholder="Client lastname" />
                                                  </div>
                                              </div>
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label>Client phone</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            [(ngModel)]="eventOffer.clientPhone"
                                                            placeholder="Client phone" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                                <li [ngbNavItem]="'tab-existing'">
                                    <a ngbNavLink>Existing Organization</a>
                                    <ng-template ngbNavContent>
                                        <div class="pt-3">
                                            <div class="form-group">
                                                <label>Company*</label>
                                                <ng-select [items]="companyOptions" class="custom"
                                                    [(ngModel)]="choosenCompany"></ng-select>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                            </ul>
                            <div [ngbNavOutlet]="editorNav"></div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col">
                            <h4 class="mt-0">Notes</h4>
                            <div class="form-group">
                                <textarea class="form-control form-control-sm" [(ngModel)]="eventOffer.notes"
                                    rows="10"></textarea>
                                <small class="help-text">
                                    This notes will be shown in the offer PDF
                                </small>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col">
                            <h4 class="mt-0">Delivery Informations</h4>
                            <div class="row">
                                <div class="col text-center">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" name="deliveryRadio"
                                            id="pickupRadio" [(ngModel)]="eventOffer.delivery" [value]="false"
                                            (change)="onDeliveryTypeRadioChange(false)">
                                        <label class="custom-control-label" for="pickupRadio"
                                            style="padding-top: 3px;"><strong>PICKUP IN OUR OFFICE</strong></label>
                                    </div>
                                </div>
                                <div class="col text-center">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" name="deliveryRadio"
                                            id="deliveryId" [(ngModel)]="eventOffer.delivery" [value]="true"
                                            (change)="onDeliveryTypeRadioChange(true)">
                                        <label class="custom-control-label" for="deliveryId"
                                            style="padding-top: 3px;"><strong>DELIVERY TO CLIENT
                                                LOCATION</strong></label>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="eventOffer.delivery === false">
                                <div class="row mt-3">
                                    <div class="col text-center" *ngFor="let pickupPoint of pickupPoints">
                                        <div class="custom-control custom-radio">
                                            <input type="radio" class="custom-control-input" name="originPlace"
                                                id="originPlace{{pickupPoint.name}}" [(ngModel)]="choosenPickupPoint"
                                                [value]="pickupPoint.id" (change)="onPickupPointChange(pickupPoint.id)">
                                            <label class="custom-control-label" for="originPlace{{pickupPoint.name}}"
                                                style="padding-top: 3px;"><strong>{{pickupPoint.name}}</strong></label>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="eventOffer.delivery === true">
                                <div class="row mt-3">
                                    <div class="offset-2 col-8">
                                        <fieldset class="scheduler-border">
                                            <legend class="scheduler-border">Delivery address</legend>
                                            <div class="row">
                                                <div class="col-4">
                                                    <app-form-group-select-validation label="Country *" name="language"
                                                        id="language" formControlNameValue="country"
                                                        [options]="countriesOptions" [formGroup]="deliveryAddressForm"
                                                        ngDefaultControl></app-form-group-select-validation>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <app-form-group-input-validation inputType="text"
                                                        label="First and last Name *" name="firstLastName"
                                                        id="firstLastName" placeHolder="First and last Name *"
                                                        formControlNameValue="firstLastName"
                                                        [error]="deliveryAddressErrorArray['firstLastName']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label class="control-label col-form-label-sm">Address *</label>
                                                        <div class="row no-gutters">
                                                            <div class="col" [formGroup]="deliveryAddressForm">
                                                                <input type="text"
                                                                    class="form-control form-control-sm {{deliveryAddressErrorArray['address'] ? 'is-invalid' : ''}}"
                                                                    formControlName="address" />
                                                                <div class="invalid-feedback"
                                                                    [hidden]="!deliveryAddressErrorArray['address']">
                                                                    {{deliveryAddressErrorArray['address'] | translate}}
                                                                </div>
                                                            </div>
                                                            <div class="col" [formGroup]="deliveryAddressForm">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    placeholder="Scala, piano, interno ecc. (Opzionale)"
                                                                    formControlName="addressDetails" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <app-form-group-input-validation inputType="text" label="City *"
                                                        name="city" id="city" placeHolder="City *"
                                                        formControlNameValue="city"
                                                        [error]="deliveryAddressErrorArray['city']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                                <div class="col">
                                                    <app-form-group-input-validation inputType="text" label="Province *"
                                                        name="province" id="province" placeHolder="Province *"
                                                        formControlNameValue="province"
                                                        [error]="deliveryAddressErrorArray['province']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                                <div class="col">
                                                    <app-form-group-input-validation inputType="text"
                                                        label="Post code *" name="postcode" id="postcode"
                                                        placeHolder="Post code *" formControlNameValue="postcode"
                                                        [error]="deliveryAddressErrorArray['postcode']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-4">
                                                    <app-form-group-input-validation inputType="text"
                                                        label="Phone number *" name="phone" id="phone"
                                                        placeHolder="Phone number *" formControlNameValue="phone"
                                                        [error]="deliveryAddressErrorArray['phone']"
                                                        [formGroup]="deliveryAddressForm" ngDefaultControl>
                                                    </app-form-group-input-validation>
                                                    <small class="form-text text-muted">Può essere utilizzato per
                                                        aiutare consegna</small>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col">
                            <h4 class="mt-0">{{'request-event-modal.software' | translate}}</h4>
                            <div class="row">
                                <div class="col">
                                    <app-form-group-number-input [(model)]="eventOffer.softwareWaiter"
                                        [label]="'request-event-modal.waiters' | translate"
                                        (modelChange)="onSoftwareTypeChange('waiter')">
                                    </app-form-group-number-input>
                                </div>
                                <div class="col">
                                    <app-form-group-number-input [(model)]="eventOffer.softwareCashRegister"
                                        [label]="'request-event-modal.cash-register' | translate"
                                        (modelChange)="onSoftwareTypeChange('cashRegister')">
                                    </app-form-group-number-input>
                                </div>
                                <div class="col">
                                    <app-form-group-number-input [(model)]="eventOffer.softwareMainDevice"
                                        [label]="'request-event-modal.main-device' | translate"
                                        (modelChange)="onSoftwareTypeChange('mainDevice')"
                                        [max]="1">
                                    </app-form-group-number-input>
                                </div>
                                <div class="col">
                                    <app-form-group-number-input [(model)]="eventOffer.softwarePrinter"
                                        [label]="'request-event-modal.printers' | translate"
                                        (modelChange)="onSoftwareTypeChange('printer')">
                                    </app-form-group-number-input>
                                </div>
                              <div class="col" *ngIf="chosenCountry?.id === 1">
                                <app-form-group-number-input [(model)]="eventOffer.softwareFiscalPrinter"
                                       [label]="'request-event-modal.fiscalPrinters' | translate"
                                       (modelChange)="onSoftwareTypeChange('fiscalPrinter')">
                                </app-form-group-number-input>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <h4 class="mt-0">{{'request-event-modal.hardware' | translate}}</h4>
                            <div class="row">
                                <div class="col">
                                    <app-form-group-number-input [(model)]="eventOffer.hardwarePhone"
                                        [label]="'request-event-modal.phones' | translate"
                                        (modelChange)="calculateEventOfferPrice()">
                                    </app-form-group-number-input>
                                </div>
                                <div class="col">
                                    <app-form-group-number-input [(model)]="eventOffer.hardwarePrinter"
                                        [label]="'request-event-modal.printers' | translate"
                                        (modelChange)="calculateEventOfferPrice()">
                                    </app-form-group-number-input>
                                </div>
                                <div class="col" *ngIf="chosenCountry?.id === 1">
                                  <app-form-group-number-input [(model)]="eventOffer.hardwareFiscalPrinter"
                                         [label]="'request-event-modal.fiscalPrinters' | translate"
                                         (modelChange)="calculateEventOfferPrice()">
                                  </app-form-group-number-input>
                                </div>
                                <div class="col">
                                    <app-form-group-number-input [(model)]="eventOffer.hardwareRouter"
                                        [label]="'request-event-modal.routers' | translate"
                                        (modelChange)="calculateEventOfferPrice()">
                                    </app-form-group-number-input>
                                </div>
                                <div class="col">
                                    <app-form-group-number-input [label]="'request-event-modal.ups' | translate"
                                        [(model)]="eventOffer.hardwareUps" (modelChange)="calculateEventOfferPrice()">
                                    </app-form-group-number-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <h4 class="mt-0">Cable</h4>
                        </div>
                        <div class="col">
                            <app-form-group-number-input [label]="'request-event-modal.cable-1m' | translate"
                                [(model)]="cableProductsAmount.one" (modelChange)="calculateEventOfferPrice()">
                            </app-form-group-number-input>
                        </div>
                        <div class="col">
                            <app-form-group-number-input [label]="'request-event-modal.cable-5m' | translate"
                                [(model)]="cableProductsAmount.five" (modelChange)="calculateEventOfferPrice()">
                            </app-form-group-number-input>
                        </div>
                        <div class="col">
                            <app-form-group-number-input [label]="'request-event-modal.cable-10m' | translate"
                                [(model)]="cableProductsAmount.ten" (modelChange)="calculateEventOfferPrice()">
                            </app-form-group-number-input>
                        </div>
                        <div class="col">
                            <app-form-group-number-input [label]="'request-event-modal.cable-20m' | translate"
                                [(model)]="cableProductsAmount.twenty" (modelChange)="calculateEventOfferPrice()">
                            </app-form-group-number-input>
                        </div>
                        <div class="col">
                            <app-form-group-number-input [label]="'request-event-modal.cable-50m' | translate"
                                [(model)]="cableProductsAmount.fifty" (modelChange)="calculateEventOfferPrice()">
                            </app-form-group-number-input>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mt-4">
                        <hr>
                        <h4 class="mt-4">Additional products and services</h4>
                      </div>
                      <div class="col">
                        <div class="row mt-3">
                          <ng-container *ngFor="let additionalCost of additionalCostsCustomArray; let i = index">
                            <div class="col-12 col-md-3 p-2">
                              <!-- groupNumber-->
                              <div class="card m-0" *ngIf="additionalCost.typeField === 'groupNumber'">
                                <h5 class="card-title text-center p-2 mb-0" style="background-color: #f5f5f5;"><strong>{{'event.additionalCosts.' + additionalCost.name + '.title' | translate}}</strong></h5>
                                <div class="card-price p-2">
                                <h5 class="text-center p-2 mb-0"><span style="white-space:nowrap; font-weight: bold;">{{additionalCost.cost}} {{additionalCost.typeShow === 'showValue' ? '€': '%'}}</span></h5>
                                </div>
                                <ul class="list-group list-group-flush">
                                <li class="list-group-item border-bottom-0 p-2">
                                  <app-form-group-number-input
                                    [offset]="additionalCost.offset"
                                    [(model)]="additionalCost.value"
                                    (modelChange)="onAdditionalCostNumberInputChange(additionalCost.name)"
                                  >
                                  </app-form-group-number-input>
                                </li>
                                </ul>
                              </div>
                              <!-- radio-->
                              <div class="card m-0" *ngIf="additionalCost.typeField === 'radio'">
                                <h5 class="card-title text-center p-2 mb-0" style="background-color: #f5f5f5;"><strong>{{'event.additionalCosts.' + additionalCost.name + '.title' | translate}}</strong></h5>
                                <div class="card-price p-2">
                                <h5 class="text-center p-2 mb-0"><span style="white-space:nowrap; font-weight: bold;">{{additionalCost.cost}} {{additionalCost.typeShow === 'showValue' ? '€': '%'}}</span></h5>
                                </div>
                                <ul class="list-group list-group-flush">
                                <li class="list-group-item border-bottom-0 p-2">
                                  <div
                                  class="row"
                                  >
                                  <div class="col text-center">
                                    <div class="form-check form-check-inline">
                                    <input class="form-check-input"
                                      type="radio"
                                      [name]="additionalCost.name"
                                      [(ngModel)]="additionalCost.value"
                                      (change)="onAdditionalCostNumberInputChange(additionalCost.name)"
                                      id="mainDeviceCheckTrue"
                                      [value]="1"
                                    />
                                    <label>Yes</label>
                                    </div>
                                  </div>
                                  <div class="col text-center">
                                    <div class="form-check form-check-inline">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      [name]="additionalCost.name"
                                      [(ngModel)]="additionalCost.value"
                                      (change)="onAdditionalCostNumberInputChange(additionalCost.name)"
                                      id="mainDeviceCheckFalse"
                                      [value]="0"
                                    />
                                    <label>No</label>
                                    </div>
                                  </div>
                                  </div>
                                </li>
                                </ul>
                              </div>
                            </div>
                            <div class="col-12 hr-space d-none d-md-block" *ngIf="additionalCost.endRow"><hr/></div>
                          </ng-container>
                          </div>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <h4 class="mt-0">Price</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-2">
                                    <div class="form-group">
                                        <label>List Price *</label>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">€ </span>
                                            </div>
                                            <input type="text" class="form-control" [(ngModel)]="eventOffer.fullPrice">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label>Discount</label>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">% </span>
                                            </div>
                                            <input type="number" class="form-control" [(ngModel)]="eventOffer.discount"
                                                (change)="calculateDiscountPrice()">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label>Client Price (no VAT) *</label>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">€ </span>
                                            </div>
                                            <input type="text" class="form-control"
                                                [(ngModel)]="eventOffer.discountedPrice" (change)="calculateVat()" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label>VAT</label>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">% </span>
                                            </div>
                                            <input type="number" class="form-control" [(ngModel)]="eventOffer.vat"
                                                (change)="calculateVat()">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label>Client Price (VAT) *</label>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">€ </span>
                                            </div>
                                            <input type="text" class="form-control"
                                                [(ngModel)]="eventOffer.discountedPriceWithVat">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col text-center">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="checkAdminEmail"
                                    [(ngModel)]="sendEmailToAdmin">
                                <label class="custom-control-label" for="checkAdminEmail" style="padding-top: 3px;">Send
                                    Offer to the
                                    <strong>admin email</strong></label>
                            </div>
                        </div>
                        <div class="col text-center">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="checkOrganizationEmail"
                                    [(ngModel)]="sendEmailToOrganization">
                                <label class="custom-control-label" for="checkOrganizationEmail"
                                    style="padding-top: 3px;">Send offer to
                                    the <strong>organization email</strong></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <a class="btn btn-default btn-sm btn-wd" href="/offers">
                                <i class="fa fa-times"></i> <br /> Cancel
                            </a>
                        </div>
                        <div class="col text-right">
                            <button class="btn btn-primary btn-sm btn-wd" type="button"
                                (click)="submitEventOfferRequest()">
                                <i class="fa fa-save"></i> <br />
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #chooseEmailModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title m-0" id="modal-basic-title">Choose email where to send the offer <input type="hidden" autofocus /></h4>
    </div>
    <div class="modal-body">
        <h5 class="border-bottom">Company</h5>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input"
              value="{{eventOffer.company.firstEmail}}" [(ngModel)]="emailToSendOffer">
          <label class="custom-control-label" for="customRadioInline1"
              style="padding-top: 3px;">{{eventOffer.company.firstEmail}}<br />
              <small class="text-muted">First Email</small></label>
          <!-- Ivan: removed first company / i don't know how and why is used before
            <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input"
                value="{{eventOffer.company.firstEmail}}-firstCompany" [(ngModel)]="emailToSendOffer">
            <label class="custom-control-label" for="customRadioInline1"
                style="padding-top: 3px;">{{eventOffer.company.firstEmail}}<br />
                <small class="text-muted">First Email</small></label>
          -->
        </div>
        <ng-container *ngIf="eventOffer.company.secondEmail">
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input"
                    value="{{eventOffer.company.secondEmail}}" [(ngModel)]="emailToSendOffer">
                <label class="custom-control-label" for="customRadioInline2"
                    style="padding-top: 3px;">{{eventOffer.company.secondEmail}}<br />
                    <small class="text-muted">Second Email</small></label>
            </div>
            <!-- Ivan: removed second company / i don't know how and why is used before
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input"
                    value="{{eventOffer.company.secondEmail}}-secondCompany" [(ngModel)]="emailToSendOffer">
                <label class="custom-control-label" for="customRadioInline2"
                    style="padding-top: 3px;">{{eventOffer.company.secondEmail}}<br />
                    <small class="text-muted">Second Email</small></label>
              </div>
            -->
        </ng-container>
        <h5 class="border-bottom mt-3">Clients</h5>
        <ng-container *ngFor="let clientUser of eventOffer.company.clientUsers; let i = index;">
            <div class="form-group">
                <strong>{{clientUser.firstName}} {{clientUser.lastName}}</strong><br />
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="customRadioInline3" name="customRadioInline1" class="custom-control-input"
                        value="{{clientUser.firstEmail}}***{{i}}" [(ngModel)]="emailToSendOffer">
                    <label class="custom-control-label" for="customRadioInline3"
                        style="padding-top: 3px;">{{clientUser.firstEmail}}<br />
                        <small class="text-muted">First Email</small></label>
                </div>
                <ng-container *ngIf="clientUser.secondEmail">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="customRadioInline4" name="customRadioInline1"
                            class="custom-control-input" value="{{clientUser.secondEmail}}***{{i}}"
                            [(ngModel)]="emailToSendOffer">
                        <label class="custom-control-label" for="customRadioInline4"
                            style="padding-top: 3px;">{{clientUser.secondEmail}}<br />
                            <small class="text-muted">Second Email</small></label>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark btn-sm btn-wd"
            (click)="modal.dismiss('Cross click')">back</button>
        <button type="button" class="btn btn-success btn-sm btn-wd" (click)="modal.close('Save click')">Submit</button>
    </div>
</ng-template>
